<script>
const key = 'visited-products';
const maxLengthOfVisitedProducts = 10;

const getVisitedProducts = () => JSON.parse(localStorage.getItem(key)) || [];
const setVisitedProducts = (products = []) => localStorage.setItem(key, JSON.stringify(products));

export default {
    data() {
        return {
            visitedProductsIds: getVisitedProducts().filter(id => id !== this.id)
        }
    },
    mounted() {
        if (this.id) {
            let visitedProducts = getVisitedProducts();

            visitedProducts.unshift(this.id)
            visitedProducts = [...new Set(visitedProducts)]

            if (visitedProducts.length > maxLengthOfVisitedProducts) {
                visitedProducts.pop()
            }

            setVisitedProducts(visitedProducts)
        }
    }
}
</script>
